// internationalization
import i18n from 'i18next';
import ChainedBackend, { ChainedBackendOptions } from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
// react
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    glossary: {
      operations: 'operations',
    },
  },
};

export function initI18n(translationsUrl: string) {
  const url = translationsUrl || 'http://localhost:3002';

  // 4. config
  i18n
    .use(ChainedBackend)

    // 3. wire react
    .use(initReactI18next)
    .init<ChainedBackendOptions>({
      fallbackLng: 'dk',
      debug: false,
      ns: [
        'common',
        'home',
        'tool-bar',
        'glossary',
        'time',
        'messages',
        'datatypes',
        'portfolio',
        'deepdive',
        'energyxplorer',
        'devices',
        'dashboards',
        'alarms',
        'analytics',
        'buildingOptimization',
        'tours',
        'backend-errors',
        'http-errors',
        'recalc-errors',
      ],
      defaultNS: 'common',
      partialBundledLanguages: true,
      interpolation: { escapeValue: false },
      react: {
        useSuspense: true,
      },
      backend: {
        backends: [HttpBackend, resourcesToBackend(resources)],
        backendOptions: [
          {
            loadPath: `${url}/locales/{{lng}}/{{ns}}.json`,
            crossDomain: true,
            allowMultiLoading: true,
            reloadInterval: 60 * 60 * 1000,
            requestOptions: {
              credentials: 'omit',
            },
          },
          { resources },
        ],
      },
    });
}

export default i18n;
